module.exports = __webpack_public_path__ + "static/media/withdrawal_qiwi.c2134955.svg";